import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="page-title"
// Listens for Turbo Frame navigation and updates the page title in the top bar
export default class extends Controller {
  static targets = ["display", "displayShort"]
  static values = {
    default: { type: String, default: "מערכת ניהול נתונים - יובל חינוך" }
  }

  connect() {
    // Listen for Turbo render to update title after page load
    document.addEventListener('turbo:render', () => this.updateTitle())
    
    // Also update on frame-load for subsequent navigations
    document.addEventListener('turbo:frame-load', this.handleFrameLoad.bind(this))
    
    // Listen for turbo:load as well
    document.addEventListener('turbo:load', () => this.updateTitle())
    
    // Try updating immediately in case Turbo has already rendered
    this.updateTitle()
  }

  disconnect() {
    document.removeEventListener('turbo:frame-load', this.handleFrameLoad.bind(this))
  }

  handleFrameLoad(event) {
    // Only update if it's the main_content frame
    if (event.target.id === 'main_content') {
      this.updateTitle()
    }
  }

  updateTitle() {
    const frame = document.getElementById('main_content')

    // Look for the hidden div with breadcrumb content
    const breadcrumbDiv = frame?.querySelector('[data-page-title-content]')
    const pageTitle = breadcrumbDiv?.innerHTML || frame?.dataset.pageTitle || this.defaultValue

    if (this.hasDisplayTarget) {
      this.displayTarget.innerHTML = pageTitle
    }
    if (this.hasDisplayShortTarget) {
      this.displayShortTarget.textContent = this.extractLastSegment(pageTitle)
    }
  }

  // Extract the deepest breadcrumb segment for the mobile-only short title.
  // Breadcrumb HTML is rendered as `<a>...</a> / <a>...</a> / <span>...</span>`,
  // so the last element child holds the current page name. Plain-text titles
  // (default fallback) have no element children — return the whole string.
  extractLastSegment(html) {
    const tmp = document.createElement('div')
    tmp.innerHTML = html
    const last = tmp.lastElementChild
    return (last ? last.textContent : tmp.textContent).trim()
  }
}
